// extracted by mini-css-extract-plugin
export default {"container":"DoctorAttachedAccomplishments_container__MqAMu","attachmentTitle":"DoctorAttachedAccomplishments_attachmentTitle__bWXxr"};